<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="2" fill="#F1F0FF"/>
    <path
      d="M11.4659 13V4H4V13H11.4659ZM11.4659 13H16V9.33333L14.0568 7H11.4659V13Z"
      stroke="#5C53A2"
      stroke-width="1.18125"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13 16.001C13.8284 16.001 14.5 15.3294 14.5 14.501C14.5 13.6725 13.8284 13.001 13 13.001C12.1716 13.001 11.5 13.6725 11.5 14.501C11.5 15.3294 12.1716 16.001 13 16.001Z"
      stroke="#5C53A2"
      stroke-width="1.18125"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 16.001C7.82843 16.001 8.5 15.3294 8.5 14.501C8.5 13.6725 7.82843 13.001 7 13.001C6.17157 13.001 5.5 13.6725 5.5 14.501C5.5 15.3294 6.17157 16.001 7 16.001Z"
      stroke="#5C53A2"
      stroke-width="1.18125"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="4.09363"
      y="4.09375"
      width="7.59375"
      height="9.28125"
      fill="#5C53A2"
    />
    <rect
      x="11.6874"
      y="10"
      width="4.21875"
      height="3.375"
      fill="#5C53A2"
    />
  </svg>
</template>
<script setup>
</script>
